export default {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    '& .MuiAutocomplete-root': {
      padding: 0,
    },
    '& .MuiPaper-root': {
      background: '#fff !important',
    },
    '& .MuiAutocomplete-listbox': {
      padding: '0 !important',
    },
    '& .MuiPopper-root': {
      padding: '0 !important',
      background: '#fff !important',
    },
  },
  icon: {
    width: '20px!important',
    height: '20px',
  },
  priceLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    button: {
      background: (theme) => theme.palette.blues.lightestBlue,
      border: 'none',
      boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15)',
      borderRadius: '12px',
      '&:hover': {
        border: 'none',
        boxShadow: '0px 4px 8px 3px rgba(0, 0, 0, 0.15)',
      },
    },
  },
};
